import { safeParseNullDefault, parseNumberStrict } from 'shouldve-been-js';

class TenantToken {

    private _token: string | null;
    private _refreshToken: string | null;
    private _expiration: Date | null;

    public constructor(token: string | null, refreshToken: string | null, expiration: Date | null) {

        this._token = token;
        this._refreshToken = refreshToken;
        this._expiration = expiration;
    }

    public get token(): string | null {
        return this._token;
    }

    public set token(value: string | null) {
        this._token = value;
    }

    public get refreshToken(): string | null {
        return this._refreshToken;
    }

    public set refreshToken(value: string | null) {
        this._refreshToken = value;
    }

    public get expiration(): Date | null {
        return this._expiration;
    }

    public set expiration(value: Date | null) {
        this._expiration = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): TenantToken {

        const token: string | null = safeParseNullDefault<string>(json?.idToken ?? json?.id_token, '');
        const refreshToken: string | null = safeParseNullDefault<string>(json?.refreshToken ?? json?.refresh_token, '');
        
        const expiresInSecondsString: string | null = safeParseNullDefault<string>(json?.expiresIn ?? json?.expires_in, '');
        const expiresInSeconds: number | null = parseNumberStrict(expiresInSecondsString);
        const expiration: Date | null = expiresInSeconds === null ? null : new Date((new Date()).getTime() + expiresInSeconds * 1000);

        return new TenantToken(token, refreshToken, expiration);
    }
}

export default TenantToken;